import { OfferType } from 'constants/enums';

import BundlesTable from './Bundles/BundlesTable';
import { BundlesForm } from './Bundles/Form/BundlesForm';
import { DailyBonusTable } from './DailyBonus/DailyBonusTable';
import { DailyBonusForm } from './DailyBonus/Form/DailyBonusForm';
import { PopupsFormV2 } from './Popups/Form/PopupsForm';
import { PopupsTable } from './Popups/PopupsTable';
import PromotionsForm from './Promotions/Form/PromotionsForm';
import PromotionsTable from './Promotions/PromotionsTable';
import { RewardCalendarForm } from './RewardCalendar/Form/RewardCalendarForm';
import { RewardCalendarTable } from './RewardCalendar/RewardCalendarTable/RewardCalendarTable';
import RollingOfferForm from './RollingOffers/Form/RollingOfferForm';
import RollingOffersTable from './RollingOffers/RollingOffersTable';

interface IOfferViewConfig {
  table: React.ComponentType;
  form: React.ComponentType<{ edit?: boolean; dup?: boolean }>;
  formParamName: string;
}

export const OFFER_VIEW_CONFIG: Record<string, IOfferViewConfig> = {
  [OfferType.BUNDLE]: {
    table: BundlesTable,
    form: BundlesForm,
    formParamName: 'offerId'
  },
  [OfferType.SPECIAL_OFFER]: {
    table: PromotionsTable,
    form: PromotionsForm,
    formParamName: 'specialOfferId'
  },
  [OfferType.POPUP]: {
    table: PopupsTable,
    form: PopupsFormV2,
    formParamName: 'popupId'
  },
  [OfferType.ROLLING_OFFER]: {
    table: RollingOffersTable,
    form: RollingOfferForm,
    formParamName: 'rollingOfferId'
  },
  [OfferType.DAILY_BONUS]: {
    table: DailyBonusTable,
    form: DailyBonusForm,
    formParamName: 'popupId'
  },
  [OfferType.REWARD_CALENDAR]: {
    table: RewardCalendarTable,
    form: RewardCalendarForm,
    formParamName: 'popupId'
  }
};
